var _circle, _circle2, _path, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350 80",
    width: 350,
    height: 80,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cleanGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#2196F3",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#9C27B0",
      stopOpacity: 1
    }
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 25,
    fill: "none",
    stroke: "url(#cleanGrad)",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 8,
    fill: "url(#cleanGrad)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 30L45 35L40 40L50 50L40 45L45 40L35 30Z",
    fill: "#FFD700",
    opacity: 0.9
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 35,
    fontFamily: "'SF Pro Display', 'Helvetica', sans-serif",
    fontSize: 22,
    fontWeight: 600,
    fill: "url(#cleanGrad)"
  }, "\n        BrightMinds\n    ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 55,
    fontFamily: "'SF Pro Display', 'Helvetica', sans-serif",
    fontSize: 16,
    fontWeight: 700,
    fill: "url(#cleanGrad)",
    letterSpacing: "1.5px"
  }, "\n        STEM EDUCATION\n    ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c446a6fd7851149d99634a5732422b36.svg";
export { ForwardRef as ReactComponent };